export enum CreatorZoom {
    NEAR,
    FAR,
    PLAYER360
}

export enum CreatorBase {
    TOWER1   = 1,
    TOWER2   = 2,
    DESKTOP1 = 5,
    DESKTOP2 = 6,
    DESKTOP3 = 7,
    MOBILE   = 10
}

enum CreatorLcdColor {
    GRAY  = 60,
    BLACK = 61,
    GOLD  = 62,
}

export enum CreatorLcdSize {
    LCD5    = 50,
    LCD7    = 51,
}

enum CreatorLogo {
    LOGO    = 90
}

const Prefixes = {
    1: 'tower',
    2: 'tower2',
    5: 'desktop1',
    6: 'desktop2',
    7: 'desktop3',
    10: 'mobile'
};

export default class Visual {
    private $el: JQuery;

    private base: CreatorBase;
    private base_color: number;
    private lcd_color?: CreatorLcdColor;
    private lcd_size?: CreatorLcdSize;
    private logo: CreatorLogo;

    private zoom: CreatorZoom;
    private mobilex: boolean;
    private oxy: boolean;
    private addons_visible: boolean;

    private $masks: JQuery;
    private $addons: JQuery;

    public constructor($el: JQuery) {
        this.$el = $el;

        this.zoom = CreatorZoom.FAR;
    }

    public initHtml(): void {
        this.$masks = $('.masks', this.$el);
        this.$addons = $('.addons', this.$el);

        for (let i = 0; i <= 4; i ++) {
            this.$masks.append($('<div>'));
        }

        this.$el.mousemove((e) => {
            let vh = this.$el.height();

            let yy = e.pageY - this.$el.offset().top;
            let py = yy / vh;

            let ah = this.$addons.height();

            this.$addons.css({
                top: ah > vh ? 30 - py * (ah - vh + 60) : 0
            });
        });

        this.update();
    }

    private setMask(i, img): void {
        let prefix_type = Prefixes[this.base];
        let prefix_view = this.zoom == CreatorZoom.NEAR ? 'near' : 'far';

        if (this.mobilex) {
            prefix_type = 'mobilex';
        }

        let $mask = this.$masks.children().eq(i);

        if (img!=null) {
            let path='/theme/images/creator/' + prefix_type + '/' + prefix_view + '/' + img;

            $mask.css({
                'background-image': "url(" + path + ")"
            });
        } else {
            $mask.css({
                'background-image': ''
            });
        }
    }

    private clearMasks(): void {
        let len = this.$masks.children().length

        for (let i = 0; i < len; i++) {
            this.setMask(i, null);
        }
    }

    public update() {
        this.clearMasks();

        switch (this.base) {
            case CreatorBase.TOWER1:
                this.setMask(0, 'bg.jpg');
                this.setMask(1, 'body_' + this.base_color + '.png');
                this.setMask(2, 'panel_' + this.lcd_size + '_' + this.lcd_color + '.png');
                this.setMask(3, 'lcd_' + this.lcd_size + '.png');
                this.setMask(4, this.oxy ? 'oxy.png' : null);
                break;

            case CreatorBase.TOWER2:
                this.setMask(0, 'bg.jpg');
                this.setMask(1, 'body_' + this.base_color + '.png');
                this.setMask(2, 'panel_' + this.lcd_color + '.png');
                this.setMask(3, 'lcd_full.png');
                this.setMask(4, this.oxy ? 'oxy.png' : null);
                break;

            case CreatorBase.DESKTOP1:
                this.setMask(0, 'bg.jpg');
                this.setMask(1, 'body_' + this.base_color + '.png');
                this.setMask(2, 'panel_' + this.lcd_size + '_' + this.lcd_color + '.png');
                this.setMask(3, 'lcd_' + this.lcd_size + '.png');
                break;

            case CreatorBase.DESKTOP2:
                this.setMask(0, 'bg.jpg');
                this.setMask(1, 'body_' + this.base_color + '.png');
                this.setMask(2, 'panel_' + this.lcd_size + '_' + this.lcd_color + '.png');
                this.setMask(3, 'lcd_' + this.lcd_size + '.png');
                break;

            case CreatorBase.DESKTOP3:
                this.setMask(0, 'bg.jpg');
                this.setMask(1, 'body_' + this.base_color + '.png');
                this.setMask(2, 'panel_' + this.lcd_size + '_' + this.lcd_color + '.png');
                this.setMask(3, 'lcd_' + this.lcd_size + '.png');
                break;

            case CreatorBase.MOBILE:
                this.setMask(0, 'bg.jpg');
                this.setMask(1, 'body_' + this.base_color + '.png');
                this.setMask(2, 'panel_' + this.lcd_size + '_' + this.lcd_color + '.png');
                this.setMask(3, 'lcd_' + this.lcd_size + '.png');
                break;

            default:
                throw 'Unknown creator base id' + this.base;
        }

        this.$el.toggleClass('xvis--base-10', this.base == 10);

        this.$el.toggleClass('xvis--near', this.zoom == CreatorZoom.NEAR);
        this.$el.toggleClass('xvis--far', this.zoom == CreatorZoom.FAR);
        this.$el.toggleClass('xvis--player360', this.zoom == CreatorZoom.PLAYER360);
        this.$el.toggleClass('xvis--addons', this.isAddonsVisible());

        this.$el.removeClass('xvis--base-1 xvis--base-2 xvis--base-5 xvis--base-6 xvis--base-7 xvis--base-10');
        this.$el.addClass('xvis--base-' + this.base);
    }

    public setBoxes(addons: any): void {
        let This = this;

        this.$addons.empty();

        let list = {};

        $.each(addons, function () {
            let $this = this;

            let images = [];

            for (let i = 1; i <= 3; i ++) {
                let image = $this.data('image' + i);

                if (image == null || image.length==0) {
                    continue;
                }

                let id = $this.data('id' + i);

                if (id != null && list[id]) {
                    continue;
                }

                list[id] = true;
                images.push(image);
            }

            $.each(images, function () {
                let $div = $('<div>');

                $div.css({
                    'background-image': "url(" + this + ")"
                });

                $div.prop('title', $this.find('.title span').text());
                $div.appendTo(This.$addons);
            });
        });

        this.$addons.removeClass('t0 t1 t2 t3 t4 t5 t6 t7 t8 t9 t10');
        this.$addons.addClass('t' + Math.ceil(this.$addons.children().length / 5));
    }

    public getZoom(): CreatorZoom {
        return this.zoom;
    }

    public setZoom(zoom: CreatorZoom): void {
        this.zoom = zoom;
    }

    public getBase(): CreatorBase {
        return this.base;
    }

    public setBase(base: CreatorBase): void {
        this.base = base;
    }

    public getBaseColor(): number {
        return this.base_color;
    }

    public setBaseColor(color: number): void {
        this.base_color = color;
    }

    public getLcdColor(): CreatorLcdColor {
        return this.lcd_color;
    }

    public setLcdColor(color: CreatorLcdColor): void {
        this.lcd_color = color;
    }

    public getLcdSize(): CreatorLcdSize {
        return this.lcd_size;
    }

    public setLcdSize(size: CreatorLcdSize): void {
        this.lcd_size = size;
    }

    public hasLogo(): CreatorLogo {
        return this.logo;
    }

    public sasLogo(logo: CreatorLogo): void {
        this.logo = logo;
    }

    public hasOxy(): boolean {
        return this.oxy;
    }

    public setOxy(oxy: boolean): void {
        this.oxy = oxy;
    }

    public hasMobileX(): boolean {
        return this.mobilex;
    }

    public setMobileX(mobilex: boolean): void {
        this.mobilex = mobilex;
    }

    public isAddonsVisible(): boolean {
        return this.addons_visible;
    }

    public setAddonsVisible(addons_visible: boolean): void {
        this.addons_visible = addons_visible;
    }

}
